import { Contract, utils } from 'ethers';

export const evm_buildTokenTransferTransaction = async (
  fromAddress: string,
  toAddress: string,
  contract: string,
  amount: number,
  decimals: number,
  chainId: string
) => {
  try {
    const ERC20_ABI = [
      'function transfer(address to, uint256 amount) returns (bool)',
      'function decimals() view returns (uint8)',
      'function balanceOf(address owner) view returns (uint256)',
    ];
    const contract_ERC20 = new Contract(contract, ERC20_ABI);
    const amountBN = utils.parseUnits(String(amount), decimals);

    // 构建交易数据
    const transferdata = contract_ERC20.interface.encodeFunctionData('transfer', [
      toAddress,
      amountBN,
    ]);
    const transactionParameters = {
      data: transferdata, // 交易数据
      to: contract, // // 代币地址
      from: fromAddress,
      chainId: chainId,
      value: '0', // 不是平台币，所以值为0
      gasLimit: '2000000',
    };
    return transactionParameters;
  } catch (error) {
    return '';
  }
};
